export default "__VITE_ASSET__DxLSfAGo__"